{
  "actions": "Ações",
  "actionsAvailable": "Ações disponíveis.",
  "clearSelection": "Limpar seleção",
  "selected": "{count, plural, =0 {Nenhum selecionado} one {# selecionado} other {# selecionados}}",
  "selectedAll": "Todos selecionados"
}
